import { render, staticRenderFns } from "./CertificateProgram.vue?vue&type=template&id=24f77174&scoped=true"
import script from "./CertificateProgram.vue?vue&type=script&lang=js"
export * from "./CertificateProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f77174",
  null
  
)

export default component.exports